<template>
  <AppDialog
    :key="key"
    class="scrollable ranking-dialog"
    append-to-body
    :show="show"
    size="large"
    :title="title"
    @close="closeDialog"
  >
    <div class="info-banner text-blue mb-20 mr-30">
      <i class="hi hi-info-filled pr-5"></i>
      <span class="info-text"> Showing Apps & URLs with at least one minute of usage </span>
    </div>
    <AppInfiniteScroll
      v-if="!firstLoad"
      max-height="80vh"
      @loadmore="loadMore"
    >
      <InsightsRankingItems
        class="insights-ranking-widget-view-more"
        :widget-key="widgetKey"
        :widget-data="widgets[widgetName]"
        :items="items"
        :type="type"
        label="Top Apps & URLs"
      />
    </AppInfiniteScroll>
    <div class="d-flex align-items-center justify-content-center p-20">
      <div
        v-if="isLoading"
        class="spinner-wrapper absolute"
      >
        <span class="hi hi-spinner hi-32 text-blue" />
      </div>
    </div>
    <template slot="action">
      <button
        class="close"
        type="button"
        data-dismiss="modal"
        aria-hidden="true"
        @click="closeDialog"
      >
        <i class="hi hi-close hi-10" />
      </button>
    </template>
  </AppDialog>
</template>

<script>
import { INSIGHTS } from '~/app_constants';
import { mapActions, mapState } from 'vuex';

import InsightsRankingItems from './InsightsRankingItems.vue';
import AppInfiniteScroll from '../AppInfiniteScroll.vue';

import AppDialog from '~/components/AppDialog.vue';
import { InsightsTracking } from '~/mixins';

export default {
  name: 'InsightsRankingDialog',
  components: {
    InsightsRankingItems,
    AppDialog,
    AppInfiniteScroll,
  },
  mixins: [InsightsTracking],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    widgetKey: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    limit: INSIGHTS.parameters.highlightsRankingViewMoreLimit,
    offset: INSIGHTS.parameters.highlightsRankingViewMoreLimit,
    firstLoad: true,
    isFullyLoaded: false,
  }),
  computed: {
    ...mapState(['widgets']),
    key() {
      return this.$options.name;
    },
    widgetName() {
      return `${this.widgetKey}_expanded`;
    },
    isLoading() {
      return this.loadingWidgets && this.loadingWidgets[this.widgetName];
    },
    items() {
      return this.widgets && this.widgets[this.widgetName]
        ? this.widgets[this.widgetName].data || this.widgets[this.widgetName]
        : null;
    },
  },
  async created() {
    await this.fetchWidgets({
      widgetKey: this.widgetKey,
      widgetName: this.widgetName,
      extraQueryParams: {
        limit: this.limit,
      },
    });
    this.firstLoad = false;
  },
  methods: {
    ...mapActions(['fetchWidgets']),
    closeDialog() {
      this.$emit('close');
    },
    setLoadedState(value = 0) {
      this.isFullyLoaded = !(
        this.widgets[this.widgetName].length % this.limit === 0 && this.widgets[this.widgetName].length !== value
      );
    },
    async loadMore() {
      if (!this.isFullyLoaded) {
        const dataLength = this.widgets[this.widgetName].length;

        await this.fetchWidgets({
          widgetKey: this.widgetKey,
          widgetName: this.widgetName,
          extraQueryParams: {
            limit: this.limit,
            offset: this.offset,
          },
          persists: true,
        });
        this.offset += this.limit;
        this.setLoadedState(dataLength);
      }
    },
  },
};
</script>
